import React, { useState } from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';
import { useSelector, shallowEqual } from 'react-redux';
import BaseLayout from 'design-components/Layout/BaseLayout';
import PropTypes from 'prop-types';

// import Layout from 'components/Layout';
import paths from '../paths';

const PrivateRoute = ({ path, component: Component }) => {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();

  const { id } = useSelector(
    (state) => ({
      id: state.auth.userData.id,
      mapId: state.auth.userData.mapId,
    }),
    shallowEqual
  );

  const handleToggle = (event, menu) => {
    setCollapsed(!collapsed);
    if (menu) {
      window.sessionStorage.setItem('activeMenu', menu);
    }
  };

  // Preserve query params when redirecting to login (for OAuth callback)
  const loginRedirect = location.search
    ? `${paths.LOGIN}${location.search}`
    : paths.LOGIN;

  return (
      <Route
        exact
        path={path}
        render={(routeProps) =>
          id ? (
            <BaseLayout
              collapsed={collapsed}
              handleToggle={handleToggle}
              setCollapsed={setCollapsed}
              {...routeProps}
            >
              <Component
                {...routeProps}
                collapsed={collapsed}
                handleToggle={handleToggle}
                setCollapsed={setCollapsed}
              />
            </BaseLayout>
          ) : (
            <Redirect to={loginRedirect} />
          )
        }
      />
    );
};

PrivateRoute.propType = {
  path: PropTypes.string.isRequired,
  component: PropTypes.element.isRequired,
};

export default PrivateRoute;
